
import { ActionService } from 'phoenix/services/actionService';
import { CommentsService }  from 'sharebase/services/commentsService'
import { DocumentViewService, OnlineUsersService } from 'real-time';
import { DocumentDataStore } from 'sharebase-app/dataStores/documentDataStore';
import { Activity } from 'sharebase/domain';
import { UserService } from 'sharebase/services/userService';
import { AuthService } from 'phoenix/services';
import { ActivityIcons } from 'sharebase-app/components/activityLog/activityLog';
import { ShareAction } from 'sharebase/components/shareDialog/shareDialog.actions';

require('./activeUserBar.styles');
const template = require('./activeUserBar.template');
const templateUserDetailsUrl = require('./activeUserBarPanel.template');

export function ActiveUserBarDirective():ng.IDirective {
	return {
		restrict: 'E',
		controller: ActiveUserBarController,
		controllerAs: 'vm',
		template,
		bindToController: true,
		scope: {
			owner: '=',
			directUsers: '=',
			inheritedUsers: '=',
			documentId: '<'
		},
		link: (scope, element, attrs, vm:ActiveUserBarController)=>{
			
		}
	}
}

ActiveUserBarDirective.$inject = [
	
];

export class ActiveUserBarController implements ng.IComponentController {
	public static $inject = [
		'pxAuthService',
		'pxActionService',
		'sbrtsDocumentViewService',
		'sbrtsOnlineUsersService',
		'sbCommentsService',
		'sbUserService',
		'$timeout',
		'$mdMedia',
		'$mdPanel'
	];

	constructor( 
		private pxAuthService:AuthService,
		private readonly pxActionService:ActionService,
		private readonly documentViews:DocumentViewService,
		private readonly onlineUsers:OnlineUsersService,
		private readonly sbCommentsService:CommentsService,
		private readonly sbUserService:UserService,
		private readonly $timeout:ng.ITimeoutService,
		private readonly $mdMedia:any,
		private readonly $mdPanel:any
	) {	
		
	}

	private documentId:number;
	private owner;
	private directUsers;
	private inheritedUsers;
	private inactiveExpanded:boolean = false;
	private itemClicked:boolean = false;
	private inactiveOpened:boolean = false;
	private showMore:boolean = false;
	private loadingUserId:number;

	public initials(name){
		let i:string[] = [];
		name=name.split(" ");
		name.forEach(n => {
			i.push(n.slice(0,1).toUpperCase());
		});
		
		return i.join('');
	}

	public isOnline(userId){
		return this.onlineUsers.otherUsers ? this.onlineUsers.otherUsers.filter(u=>{ return u.userId === userId}).length === 1 : false;
	}
	public isActive(userId){
		return this.documentViews.otherUsers ?  this.documentViews.otherUsers.filter(u=>{ return u.userId === userId}).length === 1 : false;
	}

	public get inactiveCount(){
		return this.inactiveUsers.length;
	}

	public get inactiveUsers(){
		return [this.owner].concat(this.directUsers, this.inheritedUsers).filter(u=>{ return (!this.isOnline(u.userId) && u.userId !== this.pxAuthService.userId && u.userId !== this.owner.userId)});
	}

	public get onlineDocumentUsers(){
		return this.directUsers.concat(this.inheritedUsers).filter(u=>{ 
			return (this.isOnline(u.userId) && u.userId !== this.pxAuthService.userId && u.userId !== this.owner.userId)
		});
	}
	
	public get ownerStatus(){
		if(this.isActive(this.owner.userId)){
			return 'active';
		}
		else if(this.isOnline(this.owner.userId)){
			return 'online';
		}
		else{
			return 'offline'
		}
	}

	public openShareDialog($event, targetList): void {
		this.pxActionService.emit({
			type: ShareAction.ViewShares,
			payload: {tab:0}
		}, $event);
	}

	public showUserDetails($event:MouseEvent, userId, view:number, status:string){
		this.loadingUserId = userId;
		this.itemClicked = this.inactiveExpanded;
		var position = this.$mdPanel.newPanelPosition()
		var animation = this.$mdPanel.newPanelAnimation();
		
		if(this.$mdMedia('gt-xs')){
			position
				.relativeTo($event.target)
				.addPanelPosition(this.$mdPanel.xPosition.ALIGN_END, this.$mdPanel.yPosition.BELOW);
			animation
				.openFrom($event.target)
				.withAnimation(this.$mdPanel.animation.SCALE);;
		}
		else{
			position
				.absolute()
				.bottom()
				.left()
			animation
				.openFrom({
					top: document.documentElement.clientHeight,
					left: 0
				})
				.withAnimation(this.$mdPanel.animation.SLIDE);
		}
		
		this.sbUserService.getUser(userId)
			.then(u =>{
				var config = {
					attachTo: angular.element(document.body),
					controller: ActiveUserBarPanelController,
					controllerAs: 'vm',
					template: templateUserDetailsUrl,
					panelClass: 'sba-active-user-bar-panel',
					position: position,
					animation: animation,
					locals: {
						'user': u,
						'initials': this.initials(u.UserName),
						'comment':'',
						'documentId':this.documentId,
						'userDetailView': view,
						'status': status
						
					},
					openFrom: $event,
					hasBackdrop: this.$mdMedia('xs'),
					clickOutsideToClose: true,
					escapeToClose: true,
					focusOnOpen: true,
					zIndex: 100
				};
				this.$mdPanel.open(config);
			})
			.finally(()=>{
				this.loadingUserId = null;
				if(this.$mdMedia('xs')){
					this.inactiveOpened = false;
				}
			});
	}
	
	private clearClickedItem(e){
		if(!this.itemClicked){return;}
		this.$timeout(()=>{
			this.itemClicked = false;
		},500);
	}

	public $onChanges(changes:ng.IOnChangesObject){
		if(changes.documentId){			
			this.documentViews.joinRoom(changes.documentId.currentValue);
		}
		else if(changes.inactiveCount){
			console.log('changes')
		}
	}
	public $onInit(){
		this.$timeout(()=>{
			this.showMore=true;
		},800)
	}
	public $onDestroy(){
		this.documentViews.leaveRoom();		
	}
}
export class ActiveUserBarPanelController implements ng.IComponentController {
	public static $inject = [
		'$window',
		'sbaDocumentDataStore'		
	];

	private userActivities:Activity[];
	private user;
	private documentId:number;
	private activityIcons = ActivityIcons;
	private activityLoaded:boolean = false;
	private userDetailView;
	private status:string;
	private docUrl:string = this.$window.location.href;	

	constructor(
		private readonly $window,
		private readonly sbaDocumentDataStore:DocumentDataStore
	) {	
		this.sbaDocumentDataStore.getActivities()
			.then((actities:Activity[]) => {	
				this.userActivities = actities.filter(a=>{ return a.userName === this.user.UserName }).slice(0,3);
				this.activityLoaded = true;
			});
	}
}


// WEBPACK FOOTER //
// ./src/sharebase-app/components/activeUserBar/activeUserBar.ts